module.exports = require('./helpers/bundle-url').getBundleURL('jnZxP') + "logo-dark.eefe0b7f.svg";